import { gql } from '@apollo/client';

export const GET_ORGANIZATION = gql`
  query getOrganization($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      id
      industry
      slug
      name
      type
      users {
        id
        firstName
        lastName
        email
        roleType
      }
    }
  }
`;

export const GET_ORGANIZATION_ACTIVE_CREDIT_FACILITIES = gql`
  query getOrganizationActiveCreditFacilities($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      id
      industry
      slug
      name
      type
      creditFacilities {
        id
        slug
      }
    }
  }
`;

export const GET_ORGANIZATIONS_BY_IDS = gql`
  query getOrganizationsByIds($organizationIds: [UUID!]!) {
    organizationsByIds(organizationIds: $organizationIds) {
      id
      industry
      slug
      name
      type
    }
  }
`;

// note: this query has a N+1 pattern, please use with only limited set of organizations
export const GET_ORGANIZATIONS_BY_IDS_WITH_USERS = gql`
  query getOrganizationsByIdsWithUsers($organizationIds: [UUID!]!) {
    organizationsByIds(organizationIds: $organizationIds) {
      id
      industry
      slug
      name
      type
      users {
        id
        firstName
        lastName
        email
        roleType
      }
    }
  }
`;

export const GET_CAPITAL_PROVIDERS_FOR_CREDIT_FACILITY = gql`
  query GetCapitalProviders($creditFacilityId: UUID!) {
    capitalProviders(creditFacilityId: $creditFacilityId) {
      id
      name
      type
      slug
      industry
    }
  }
`;

export const GET_ORGANIZATION_LOAN_PRODUCTS = gql`
  query GetOrganizationLoanProducts($organizationId: UUID!) {
    organization(organizationId: $organizationId) {
      id
      slug
      loanProducts {
        id
        name
        slug
        currentMasterLoanTape {
          id
          fileVersion
          reportingDate
        }
      }
    }
  }
`;

export const GET_ORGANIZATION_LOAN_PRODUCTS_WITH_CURRENT_CREDIT_FACILITIES = gql`
  query GetOrganizationLoanProductsWithCurrentCreditFacilities(
    $organizationId: UUID!
  ) {
    organization(organizationId: $organizationId) {
      id
      slug
      loanProducts {
        id
        name
        slug
        currentMasterLoanTape {
          id
          fileVersion
          reportingDate
        }
        currentCreditFacilities
      }
    }
  }
`;

export const GET_ATHENA_SCHEMA_FOR_ORGANIZATION = gql`
  query GetAthenaSchemaForOrganization(
    # @jendevelops [GLOBAL-FILTERS TODO]: update query to take in UUID instead
    $organizationId: String!
  ) {
    athenaTables: getAthenaTablesForOrganization(
      organizationId: $organizationId
      tablePrefixes: ["receivable_response_tapes"]
    ) {
      tableName
      properties {
        name
        type
      }
    }
  }
`;

// ==== MUTATIONS ====

export const CREATE_USER = gql`
  mutation createUser($userData: CreateUser!) {
    createUser(userData: $userData) {
      id
      firstName
      lastName
      email
      roleType
    }
  }
`;

export const REMOVE_USER = gql`
  mutation removeUser($userId: UUID!, $organizationId: UUID!) {
    removeUser(userId: $userId, organizationId: $organizationId)
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($settings: UpdateUserSettings!) {
    updateUserSettingsWithRole(settings: $settings) {
      id
      email
      firstName
      lastName
      roleType
    }
  }
`;
